import { render } from "./AcceptanceWelcomeTipsOffcanvas.vue?vue&type=template&id=6b72776e&scoped=true"
import script from "./AcceptanceWelcomeTipsOffcanvas.vue?vue&type=script&lang=js"
export * from "./AcceptanceWelcomeTipsOffcanvas.vue?vue&type=script&lang=js"

import "./AcceptanceWelcomeTipsOffcanvas.vue?vue&type=style&index=0&id=6b72776e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b72776e"]])

export default __exports__